import type { ReactNode } from "react";

type BadgeTone = "primary" | "accent" | "secondary" | "neutral";

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  icon?: string;
}

const toneClasses: Record<BadgeTone, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-300",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  neutral: "bg-background-100 text-foreground-700 border-background-300",
};

export default function Badge({ children, tone = "neutral", icon }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium leading-none ${toneClasses[tone]}`}
    >
      {icon ? (
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className={`${icon} text-[13px]`} />
        </span>
      ) : null}
      {children}
    </span>
  );
}